/** 본인인증 초기화(친구 초대 QA) — 프로덕션에서도 쓰지만 admin@sweatch.ai 로그인일 때만 메뉴·페이지를 보인다. 서버도 이 계정 말고는 403 */
export const PHONE_VERIFICATION_RESET_PATH = "/test-support/phone-verification";
const RESET_ADMIN_EMAIL = "admin@sweatch.ai";

export const canUsePhoneVerificationReset = (adminEmail: string | null) =>
  adminEmail === RESET_ADMIN_EMAIL;
